import { useLingui } from '@lingui/react';
import {
    useEffect, useRef, useState
} from 'react';

import { buildIdentityProps } from './identity';
import { useAnalyticsClient } from './use-analytics-client';
import { QueryParams } from '@config/react-router-dom/hooks/query-params.types';
import { useQueryParams } from '@config/react-router-dom/hooks/use-query-params';

export const useAnalyticsIdentity = () => {
    const client = useAnalyticsClient();
    const queryParams = useQueryParams();
    const { i18n: { locale } } = useLingui();
    const identifiedRef = useRef(false);
    const [isIdentityReady, setIsIdentityReady] = useState(false);

    useEffect(() => {
        if (identifiedRef.current || !client) return;

        const userProfileId = queryParams.get(QueryParams.userProfileId);

        if (!userProfileId) return;

        identifiedRef.current = true;
        client.setCommonProps(buildIdentityProps(queryParams, locale));
        client.identify();
        setIsIdentityReady(true);
    }, [client, queryParams, locale]);

    return isIdentityReady;
};
